import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LLTTFParticipantEmailVerificationModel, LLTTFParticipantEmailModelDefaultValue } from 'src/app/components/invitations/llttf-invitations/llttf-invitations';
import { LlttfInvitationService } from 'src/app/services/llttf-invitation.service';

@Component({
    selector: 'app-llttf-email-verification',
    templateUrl: './llttf-email-verification.component.html',
    styleUrls: ['./llttf-email-verification.component.scss'],
    standalone: false
})
export class LlttfEmailVerificationComponent {

  llttfparticipantemailmodel:LLTTFParticipantEmailVerificationModel=LLTTFParticipantEmailModelDefaultValue();
  hideEmailForm:boolean=false;
  headerMessage:string="Please confirm your email address below to register for the Living Life to the Full Program.";
  inviteGuid:string=''
  

  constructor(private _llttfservice:LlttfInvitationService,private route:ActivatedRoute){}
  ngOnInit(): void {
    this.route.params.subscribe(params=>{
      this.inviteGuid=params['guid'];  
      
    })
  }

  onSubmit()
  {
    this.llttfparticipantemailmodel.invitationGuid=this.inviteGuid;
    this._llttfservice.sendLLTTFVerificationEmail(this.llttfparticipantemailmodel).subscribe({
      next: (response) => 
        {
           if(response)
           {
              this.headerMessage="Check your email."
              this.hideEmailForm=true;
           }
        }
    })
    
  }
}
